<script setup lang="ts">
import { LucideCalendar, LucideEye, LucideFolder, LucideUser } from 'lucide-vue-next'
import type { INews } from '~/components/entity/news'

const props =
  defineProps<Pick<INews, 'views_count' | 'publication_datetime' | 'categories' | 'user'>>()
</script>

<template>
  <div
    class="flex justify-between border-t bg-white p-4 text-sm sm:flex-row [&_a]:text-blue-600 [&_a]:underline hover:[&_a]:no-underline [&_svg]:size-4"
  >
    <div class="flex flex-col justify-start gap-1.5 md:flex-row md:gap-4">
      <div v-if="props.publication_datetime" class="flex items-center gap-1">
        <LucideCalendar />
        <span>{{ useTimeFormat(props.publication_datetime) }}</span>
        <NuxtLinkLocale
          :to="`/news/${props.publication_datetime.slice(0, 10).replaceAll('-', '/')}`"
          >{{ useDateFormat(props.publication_datetime) }}</NuxtLinkLocale
        >
      </div>

      <div v-if="props.categories && props.categories.length > 0" class="flex items-center gap-1">
        <LucideFolder class="mr-1" />
        <template v-for="(category, index) in props.categories" :key="category.id">
          <span>
            <NuxtLinkLocale :to="category.url" class="text-blue-600 hover:underline">
              {{ category.title }}
            </NuxtLinkLocale>
            <span v-if="index < props.categories.length - 1">,</span>
          </span>
        </template>
      </div>
    </div>

    <div class="flex flex-col gap-1.5 md:flex-row md:gap-4">
      <div v-if="props.user" class="flex items-center gap-1">
        <LucideUser />
        <NuxtLinkLocale :to="props.user.url">{{ props.user.fullname }}</NuxtLinkLocale>
      </div>
      <div class="flex items-center justify-end gap-1">
        <LucideEye />
        {{ props.views_count }}
      </div>
    </div>
  </div>
</template>
